/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gyms_Place_TitleInputs */

const en_gyms_place_title = /** @type {(inputs: Gyms_Place_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gym`)
};

const pl_gyms_place_title = /** @type {(inputs: Gyms_Place_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siłownia`)
};

/**
* | output |
* | --- |
* | "Gym" |
*
* @param {Gyms_Place_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const gyms_place_title = /** @type {((inputs?: Gyms_Place_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gyms_Place_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_gyms_place_title(inputs)
	return en_gyms_place_title(inputs)
});